'use es6';

import HoverButton from './HoverButton';
import { SMALL_RESPONSIVE_SIZE } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
const RoundedButton = props => {
  const shouldRenderWithText = props.responsiveSize !== SMALL_RESPONSIVE_SIZE && props.label;
  return /*#__PURE__*/_jsx(HoverButton, Object.assign({}, props, {
    borderRadius: shouldRenderWithText ? '20px' : '50%'
  }));
};
export default RoundedButton;